export const selectSavedSearches = state => state.savedSearches.data
export const selectSavedSearchesLoading = state => state.savedSearches.loading
